<template>
  <vs-wrapper v-if="formsWithSubmissionInfo.length > 0">
    <template v-for="form in formsWithSubmissionInfo">
      <job-inline-form
        v-if="form.isFilledOut"
        :key="form.formSubmissionUuid"
        class="pt-2"
        :form-submission-id="form.formSubmissionUuid"
        :can-edit="!jobIsApproved"
        @edit-form-submission="editJobFormSubmission(form.formId, form.formSubmissionUuid)"
      />
      <v-row v-else :key="form.formUuid">
        <v-col class="shrink">
          <v-icon small>mdi-clipboard-text-outline</v-icon>
        </v-col>
        <v-col class="grow">
          <vs-text>{{ form.name }}</vs-text>
        </v-col>

        <v-col class="shrink">
          <vs-button
            data-test="fill-job-form"
            label="Fill out"
            type="secondary"
            small
            :disabled="props.isNew"
            @click="fillJobFormSubmission(form.formUuid)"
          />
        </v-col>
      </v-row>
    </template>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import JobInlineForm from './JobInlineForm.vue'
import JobFormSubmission from '@/models/job_form_submission'
import { computeFormsWithSubmissionInfo } from './JobForm'
import { FormAssociation } from '@/models/activity'

const props = defineProps<{
  jobIsApproved?: boolean
  isNew?: boolean
  jobFormAssociations: FormAssociation[]
  jobFormSubmissions: JobFormSubmission[]
}>()

const emit = defineEmits<{
  (e: 'edit-job-form-submission', arg: { formUuid: string; formSubmissionUuid: string }): void
  (e: 'fill-job-form-submission', arg: { formUuid: string }): void
}>()

const formsWithSubmissionInfo = computed(() => {
  return computeFormsWithSubmissionInfo(props.jobFormSubmissions, props.jobFormAssociations)
})

const editJobFormSubmission = (formUuid: string, formSubmissionUuid: string) => {
  emit('edit-job-form-submission', { formUuid, formSubmissionUuid })
}

const fillJobFormSubmission = (formUuid: string) => {
  emit('fill-job-form-submission', { formUuid })
}
</script>
